import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import Input from "Components/Input";
import { Grid } from "@mui/material";
// Helpers
import { OrderData } from 'Core/data/Helpers';
// Components
import { Form } from "Components";
import Select from 'Components/Select';
import Slider from "Components/Slider";

export const FSMMealBreak = (props) => {
    const { value, onChange, formRef } = props;
    const { messages } = useIntl();

    useEffect(() => {
        if (value.triggerDuration == undefined)
            onChange({
                ...value,
                triggerDuration: {
                    duration: 'Hours',
                    value: 2
                }
            })
    }, [value])

    const dropdownOptions = [
        { selectId: 0, name: `${messages['none']}` },
        { selectId: 30, name: `30 ${messages['mins']}` },
        { selectId: 45, name: `45 ${messages['mins']}` },
        { selectId: 60, name: `60 ${messages['mins']}` },
        { selectId: 90, name: `90 ${messages['mins']}` },
        { selectId: 120, name: `120 ${messages['mins']}` },
    ];

    return (
        <Form ref={formRef}>
            <div
                style={{
                    fontWeight: "bold",
                    marginBottom: 10,
                    fontSize: 16
                }}
            >
                {messages['alertsNewAlert_notifyAt']}
            </div>

            <Grid
                container
                direction="row"
                justifyContent="flex-start"
                alignItems="center"
                spacing={1}
            >
                <Grid item xs>
                    <label className="input-normal-label">
                        {messages["alertsNewAlert_hoursLabel"]}
                    </label>
                    <Slider
                        min={2}
                        max={10}
                        value={value.triggerDuration?.value}
                        onChange={(event) => {
                            onChange({ ...value, triggerDuration: { ...value.triggerDuration, value: event } })
                        }}
                        sliderOneColor={false}
                        showValue={false}
                        valueLabelDisplay={'off'}
                    />
                </Grid>

                <Grid item>
                    <Input
                        id="fsmBreakMealHour"
                        placeholder={messages["Hours"]}
                        type="number"
                        min={2}
                        max={10}
                        value={value.triggerDuration?.value}
                        className="conDrivingHour"
                        required={false}
                        maxLength={2}
                        onChange={(event) => {
                            onChange({ ...value, triggerDuration: { ...value.triggerDuration, value: event } })
                        }}
                    />
                </Grid>
            </Grid>

            <div>
                <Select
                    required
                    value={dropdownOptions.find((option) => option.selectId === value.breakDurationMinutes)}
                    onChange={(selected) => onChange({ ...value, breakDurationMinutes: selected.selectId })}
                    id="breakDurationMinutes"
                    placeholder={messages['alertsNewAlert_breakDuration']}
                    options={dropdownOptions}
                    textField="name"
                    valueField="selectId"
                    label={messages['alertsNewAlert_breakDuration']}
                    requiredMessage={messages['required_field']}
                />
            </div>
        </Form>
    );
};
